import React, { useState } from 'react';
import { McpLogo } from './Logos';
import { ClaudeLogo } from './Logos/ClaudeLogo';
import { clientBrandAssets, getClientBrand } from './clientBrandAssets';

interface Props {
  clientName: string;
  logoUri?: string | null;
}

export function ClientLogo({ clientName, logoUri }: Props) {
  const [failedLogoUri, setFailedLogoUri] = useState<string>();
  // Client-supplied branding takes precedence for every app, including custom clients.
  if (logoUri && /^https:\/\//i.test(logoUri) && logoUri !== failedLogoUri) {
    return (
      <img
        src={logoUri}
        alt={clientName}
        className="size-10 object-contain"
        referrerPolicy="no-referrer"
        onError={() => setFailedLogoUri(logoUri)}
      />
    );
  }

  const brand = getClientBrand(clientName);
  if (brand) {
    const asset = clientBrandAssets[brand];
    if (brand === 'claude' || brand === 'claude-code') return <ClaudeLogo label={asset.label + ' logo'} />;
    return (
      <svg
        role="img"
        aria-label={asset.label + ' logo'}
        viewBox={asset.viewBox}
        className="size-8 text-default"
        fill="currentColor"
        fillRule="evenodd"
      >
        <path d={asset.path} clipRule="evenodd" />
      </svg>
    );
  }
  return (
    <span role="img" aria-label="MCP client">
      <McpLogo />
    </span>
  );
}
